import {PackageVariablesLibs, RoutePathLibs} from 'bc-react-package'

const COMP_NAME = "Globals"

// let marrReturnFromApp = []

/*===========================================
summary: 取得 預約 的 顯示時間
  param: 

retruns: 
remarks: 000 Tim 2021/05/27 Create
===========================================*/
function GetScheduleDisplayTime(TimeString)
{
    let strDisplayTime = ""

    let arrTime = TimeString.split(":")
    let intHours = parseInt(arrTime[0])
    let intMinutes = parseInt(arrTime[1])
    let intHours4Display = 0
    let strHours = ""
    let strMinutes = ""

    if (intHours > 12)
    {
        intHours4Display = intHours - 12
    }
    else
    {
        intHours4Display = intHours
    }

    // strHours = PadLeft(intHours4Display.toString(), 2)
    // strMinutes = PadLeft(intMinutes.toString(), 2)
    strHours = intHours4Display.toString().PadLeft(2)
    strMinutes = intMinutes.toString().PadLeft(2)

    strDisplayTime = strHours + ":" + strMinutes
    if (
        (intHours < 12) ||
        (intHours === 24)
        )
    {
        strDisplayTime += " AM"
    }
    else
    {
        strDisplayTime += " PM"
    }


    return strDisplayTime
} // end of GetScheduleDisplayTime

/*===========================================
summary: 取得使用者 顯示名稱
  param: 

retruns: 
remarks: 000 Tim 2020/11/09 Create
===========================================*/
function GetDisplayName()
{
    console.log(COMP_NAME + ".GetDisplayName: ", window.gSession.Acc.Profile)

    let strDisplayName = ''
    if (
        (window.gSession.Acc.ID !== 0) &&                               // 有登入
        (typeof (window.gSession.Acc.Profile) !== 'undefined') &&
        (window.gSession.Acc.Profile !== null) &&
        (typeof (window.gSession.Acc.Profile.FirstName) !== 'undefined') &&
        (typeof (window.gSession.Acc.Profile.LastName) !== 'undefined') &&
        (typeof (window.gSession.Acc.LoginName) !== 'undefined') &&
        // (window.gSession.Acc.Profile.FirstName !== '') &&
        // (window.gSession.Acc.Profile.LastName !== '') &&
        (window.gSession.Acc.LoginName !== '')
        )
    {
        strDisplayName = FormateDisplayName(window.gSession.Acc.Profile.FirstName
            , window.gSession.Acc.Profile.LastName
            , window.gSession.Acc.LoginName)
    }

    return strDisplayName.trim()
} // end of GetDisplayName

/*===========================================
summary: 取得 使用者顯示名稱
  param: 

retruns: 
remarks: 000 Tim 2020/11/09 Create
===========================================*/
function FormateDisplayName(FirstName, LastName, LoginName)
{
    // console.log(COMP_NAME + ".FormateDisplayName")
    let strDisplayName = ''

    if (
        (typeof (FirstName) !== "undefined") &&
        (FirstName !== null) &&
        (typeof (LastName) !== "undefined") &&
        (LastName !== null) &&
        (typeof (LoginName) !== "undefined") &&
        (LoginName !== null)
        )
    {
        // 第一個字轉大寫
        let strFirstName = FirstName.trim()
        let strLastName = LastName.trim()
        let strLoginName = LoginName.trim()

        // FirstName 第一個字 轉大寫
        if (strFirstName !== "")
        {
            strFirstName = strFirstName.toUpperCase().charAt(0) + strFirstName.substring(1)
        }

        // LastName 第一個字 轉大寫
        if (strLastName !== "")
        {
            strLastName = strLastName.toUpperCase().charAt(0) + strLastName.substring(1)
        }

        strDisplayName = strLoginName

        if (strFirstName.trim() !== "")
        {
            strDisplayName = strFirstName
            if (strLastName.trim() !== "")
            {
                // 顯示完整的First Name 但Last Name只顯示第一個字
                strDisplayName = strDisplayName + " " + strLastName.trim().substring(0, 1).toUpperCase() + "."
            }
        }
    }

    return strDisplayName
} // end of FormateDisplayName


/*===========================================
summary: 取得 使用者顯示名稱
  param: 

retruns: 
remarks: 000 Tim 2020/09/18 Create
===========================================*/
function GetUserDisplayName(FirstName, LastName, LoginName)
{
    // console.log(COMP_NAME + ".GetUserDisplayName: ", FirstName, LastName, LoginName)
    let strDisplayName = ''

    // 第一個字轉大寫
    let strFirstName = FirstName.trim()
    let strLastName = LastName.trim()
    let strLoginName = LoginName.trim()

    if (strFirstName !== "")
    {
        strFirstName = strFirstName.toUpperCase().charAt(0) + strFirstName.substring(1)
    }
    if (strLastName !== "")
    {
        strLastName = strLastName.toUpperCase().charAt(0) + strLastName.substring(1)
    }
    if (strLoginName !== "")
    {
        strLoginName = strLoginName.toUpperCase().charAt(0) + strLoginName.substring(1)
    }

    let strFullName = strFirstName + strLastName.slice(0, 1).trim()

    if (strFullName.length > 8)
    {
        strDisplayName = strFirstName.slice(0, 6).trim() + '.' + strLastName.slice(0, 1).trim()
    }
    else if ((strFullName.length <= 8) && (strFullName.length > 0))
    {
        strDisplayName = strFirstName + strLastName.slice(0, 1).trim()
    }
    else if (strFullName === "")
    {
        if (strLoginName.length > 8)
        {
            strDisplayName = strLoginName.slice(0, 7).trim() + '.'
        }
        else
        {
            strDisplayName = strLoginName
        }
    }

    return strDisplayName
} // end of GetUserDisplayName

/*===========================================
summary: 檢查 授權
remarks: 000 Tim 2020/11/11 Create
===========================================*/
function CheckAuthorized(AccountAuthorizedList, BookCatID, BookSeqNo)
{
    // console.log(COMP_NAME + ".CheckAuthorized: ", AccountAuthorizedList, BookCatID, BookSeqNo)

    let blnExpired = true
    let objAuthorized = null

    if (AccountAuthorizedList !== null)
    {
        objAuthorized = GetAuthorized(AccountAuthorizedList, BookCatID, BookSeqNo)

        if (
            (typeof (objAuthorized.ExpiredTime) !== 'undefined') &&
            (objAuthorized.ExpiredTime !== null) &&
            (objAuthorized.ExpiredTime !== "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
            )
        {
            blnExpired = AuthorizedIsExpired(objAuthorized.ExpiredTime)
        }
    }

    return blnExpired
} // end of CheckAuthorized

/*===========================================
summary: 取得 授權
  param: 

retruns: 
remarks: 000 Tim 2020/11/11 Create
===========================================*/
function GetAuthorized(AccountAuthorizedList, BookCatID, BookSeqNo)
{
    let blnFound = false

    let intIndex = 0
    let intCount = AccountAuthorizedList.length
    let objAuthorized = null

    while ((!blnFound) && (intIndex < intCount))
    {
        if (
            (parseInt(AccountAuthorizedList[intIndex].BookCategoryID) === BookCatID) &&
            (parseInt(AccountAuthorizedList[intIndex].BookSeqNo) === BookSeqNo)
            )
        {
            objAuthorized = AccountAuthorizedList[intIndex]
            blnFound = true
        }
        intIndex++
    }

    return objAuthorized
} // end of GetAuthorized

/*===========================================
summary: 判斷 授權是否過期
remarks: 000 Tim 2016/07/05 Create
         001 Tim 2022/11/28 用本地時間 LoaclTime 比較
===========================================*/
function AuthorizedIsExpired(ExpiredTime)
{
    console.log(COMP_NAME + ".AuthorizedIsExpired: ", ExpiredTime)

    let blnExpired = true

    let datNow = new Date()
    let datExpiredTime = null

    console.log("datNow: ", datNow)

    if (
        (ExpiredTime === null) ||
        (ExpiredTime === "") ||
        (ExpiredTime === "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
        )
    {
        blnExpired = true
    }
    else
    {
        // DB時間已經是 UTC了
        // 轉本地時間          Tim22.12.02
        datExpiredTime = ExpiredTime.replace(/\//g, '-').replace('T', ' ').replace('Z', ' ').ToUTC()

        // datNow、datExpiredTime 都用本地時間 LoaclTime 比較
        if (datNow.getTime() > datExpiredTime.getTime())
        {
            // datNow > datExpiredTime
            blnExpired = true
        }
        else
        {
            blnExpired = false
        }
    }

    console.log("blnExpired: ", blnExpired)
    return blnExpired
} // end of AuthorizedIsExpired

// /*
// richard 20230815 removed, 
// 看來都已經搬到 public/Libs/BC/Gateway.js 了
// /*===========================================
// summary: App回傳資料暫存
//   param: int    CallAction
//          string QueryString

// retruns: 
// remarks: 000 Tim 2020/11/16 Create
// ===========================================*/
// function SetReturnFromApp(CallAction, Data)
// {
//     if (marrReturnFromApp[CallAction])
//     {
//         marrReturnFromApp[CallAction] += Data
//     }
//     else
//     {
//         marrReturnFromApp[CallAction] = Data
//     }
// } // end of SetReturnFromApp

// /*===========================================
// summary: 取得App回傳資料暫存total
//   param: string QueryString

// retruns: 
// remarks: 000 Tim 2020/11/16 Create
// ===========================================*/
// function GetTotalFromApp(CallAction)
// {
//     return marrReturnFromApp[CallAction]
// } // end of GetTotalFromApp
// */

// /*===========================================
// summary: 清空回傳資料暫存
//   param: int    CallAction
//          string QueryString

// retruns: 
// remarks: 000 Tim 2020/11/16 Create
// ===========================================*/
// function ResetReturnFromAppByCallAction(CallAction)
// {
//     marrReturnFromApp[CallAction] = ''
// } // end of ResetReturnFromAppByCallAction

/*===========================================
summary: 取得 班級身份 
remarks: 000 Tim 2020/11/19 Create
===========================================*/
function GetClassAccountRole(ClassIndex)
{
    let intAccountRole = window.gConst.CLASS_ACCOUNT_ROLE_PERSONAL

    // AccountID: "498"
    // AccountRole: "1"
    // FirstName: "Cuter"
    // LastName: "Hsu"
    // LoginName: "shucuter@gmail.com"

    if (
        (window.gSession.Acc.Class === null) ||
        (window.gSession.Acc.Class.length <= 0) ||
        (typeof (window.gSession.Acc.Class[ClassIndex]) === 'undefined') ||
        (typeof (window.gSession.Acc.Class[ClassIndex].AccountRole) === 'undefined')
        )
    {
        // Personal 個人帳號 無Class
        intAccountRole = window.gConst.CLASS_ACCOUNT_ROLE_PERSONAL

        console.log("GetClassAccountRole: 1")
    }
    else if (parseInt(window.gSession.Acc.Class[ClassIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
    {
        // Teacher 老師
        intAccountRole = window.gConst.CLASS_ACCOUNT_ROLE_TEACHER
        console.log("GetClassAccountRole: 2")
    }
    else
    {
        // Student 學生
        intAccountRole = window.gConst.CLASS_ACCOUNT_ROLE_STUDENT

        console.log("GetClassAccountRole: 3")
    }

    console.log("GetClassAccountRole: intAccountRole:", intAccountRole)

    return intAccountRole
} // end of GetClassAccountRole

/*===========================================
summary: 取得 是否 有學生 身份 
remarks: 000 Tim 2020/11/19 Create
===========================================*/
function GetHaveStudentByClassAccountRole()
{
    let blnHaveStudent = false
    let intAccountRole = GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

    if (
        (intAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_PARENT) &&
        (intAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_PERSONAL)
        )
    {
        // 不是 家長 也不是 個人
        let intIndex = 0
        let intCount = window.gSession.Acc.Class.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (parseInt(window.gSession.Acc.Class[intIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
            {
                blnFound = true
                blnHaveStudent = true
            }

            intIndex++
        } // end of while
    } // end of if 

    return blnHaveStudent
} // end of GetHaveStudentByClassAccountRole

/*===========================================
summary: 取得 是否 有學生 身份 
remarks: 000 Tim 2020/11/19 Create
===========================================*/
function GetHaveTeacherByClassAccountRole()
{
    let blnHaveTeacher = false
    let intAccountRole = GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

    if (
        (intAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_PARENT) &&
        (intAccountRole !== window.gConst.CLASS_ACCOUNT_ROLE_PERSONAL)
        )
    {
        // 不是 家長 也不是 個人
        let intIndex = 0
        let intCount = window.gSession.Acc.Class.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (parseInt(window.gSession.Acc.Class[intIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                blnFound = true
                blnHaveTeacher = true
            }

            intIndex++
        } // end of while
    } // end of if 

    return blnHaveTeacher
} // end of GetHaveTeacherByClassAccountRole

/*===========================================
summary: 取得 班級Index By ClassID
remarks: 000 Tim 2021/07/30 Create
===========================================*/
function GetClassIndexByClassID(ClassID)
{
    let intIndex = 0
    let intCount = window.gSession.Acc.Class.length
    let blnFound = false
    let intClassIndex = -1

    while ((!blnFound) && (intIndex < intCount))
    {
        if (parseInt(window.gSession.Acc.Class[intIndex].ClassID) === parseInt(ClassID))
        {
            blnFound = true
            intClassIndex = intIndex
        }
        intIndex++
    } //end of while

    return intClassIndex
} // end of GetClassIndexByClassID

// 取得縮圖的路徑 (比正常的圖的路徑多thumbnail)
function GetImageThumbnailURL(LessonID, FileName)
{
    const FUNC_NAME = "GetImageThumbnailURL"
    console.log(COMP_NAME + "." + FUNC_NAME + ":", LessonID, FileName)

    let strLessonFolder = "Lesson_" + LessonID
    let strResourceTypeFolder = "image"

    let strUrl = PackageVariablesLibs.SysConfig.FileServerURL
    strUrl += strLessonFolder
    strUrl += "/"
    strUrl += strResourceTypeFolder
    strUrl += "/"
    strUrl += "thumbnails"
    strUrl += "/"
    strUrl += FileName
    console.log(COMP_NAME + "." + FUNC_NAME + " strUrl: ", strUrl)
    return strUrl
}

function GetResourceUrl(BookCategoryID, LessonID, ResourceType, FileName)
{
    console.log(COMP_NAME + ".GetResourceUrl: ", LessonID, ResourceType, FileName)

    let strLessonFolder = "Lesson_" + LessonID
    let strResourceTypeFolder = "image"

    switch (ResourceType)
    {
        case window.gResourceTypeEnum.Audio:
            strResourceTypeFolder = "audio"
            break
        case window.gResourceTypeEnum.Video:
            strResourceTypeFolder = "video"
            break
        default:
            break
    }

    let strUrl = PackageVariablesLibs.SysConfig.FileServerURL + strLessonFolder + "/" + strResourceTypeFolder + "/" + FileName
    // console.log("strUrl: ", strUrl)
    return strUrl
} // end of GetResourceUrl

/*===========================================
summary: 取得 授權名稱
    param: 

retruns: 
remarks: 000 Tim 2021/04/26 Create
===========================================*/
// function GetAuthorizedName(BookCategoryID, BookSeqNo)
// {
//     console.log(COMP_NAME + ".GetAuthorizedName")

//     let strName = ""

//     if (parseInt(BookCategoryID) === window.gBookCatIDEnum.MFCR)
//     {
//         strName = window.gAppUI.LBL_MyFirstChineseReader + " " + parseInt(BookSeqNo)
//     }
//     else if (parseInt(BookCategoryID) === window.gBookCatIDEnum.MFCW)
//     {
//         strName = window.gAppUI.LBL_MyFirstChineseWords + " " + parseInt(BookSeqNo)
//     }
//     else if (parseInt(BookCategoryID) === window.gBookCatIDEnum.ILC)
//     {
//         strName = window.gAppUI.LBL_ILoveChinese
//     }
//     else if (parseInt(BookCategoryID) === window.gBookCatIDEnum.MTC)
//     {
//         strName = window.gAppUI.LBL_MagicalTourOfChina + " " + parseInt(BookSeqNo)
//     }

//     return strName
// } // end of GetAuthorizedName

function GetBookCategoryChineseName(BookCatID, Lang)
{
    console.log(COMP_NAME + ".GetBookCategoryChineseName")
    let strTitle = ""

    let i = 0
    let blnFound = false
    let intBookCatID = parseInt(BookCatID)
    let intLang = parseInt(Lang)
    while (
        (!blnFound) &&
        (i < window.gBookCatData.length)
        )
    {
        if (parseInt(window.gBookCatData[i].ID) === intBookCatID)
        {
            blnFound = true
            strTitle = (intLang === window.gLangTypeEnum.Major) ? window.gBookCatData[i].MajorTitle : window.gBookCatData[i].MinorTitle
        }
        i++
    }
    return strTitle
}

function GetBookCategoryEnglishName(BookCatID)
{
    console.log(COMP_NAME + ".GetBookCategoryEnglishName")
    let strTitle = ""

    let i = 0
    let blnFound = false
    let intBookCatID = parseInt(BookCatID)

    while (
        (!blnFound) &&
        (i < window.gBookCatData.length)
        )
    {
        if (parseInt(window.gBookCatData[i].ID) === intBookCatID)
        {
            blnFound = true
            strTitle = window.gBookCatData[i].Title
        }
        i++
    }
    return strTitle
}

/*===========================================
summary: 取得 Iframe Video Player Url
remarks: 000 Tim 2021/03/15 Cteate
===========================================*/

/*===========================================
summary: 取得 Iframe QueryString 4 InApp
remarks: 000 Tim 2021/09/01 Cteate
===========================================*/
function GetQueryString4InApp()
{
    let strInApp4QueryString = "&InApp=false"

    if (window.gSession.App.InApp)
    {
        strInApp4QueryString = "&InApp=true"
    }

    return strInApp4QueryString
} // end of GetQueryString4InApp

/*===========================================
summary: 取得 呼叫 Roger BC Class網站的 InApp QueryString
remarks: 000 Tim 2022/06/16 Cteate
===========================================*/
function GetInAppQueryString4BCClass()
{
    let strInApp4QueryString = "&inApp=false"

    if (window.gSession.App.InApp)
    {
        strInApp4QueryString = "&inApp=true"
    }

    return strInApp4QueryString
} // end of GetInAppQueryString4BCClass


/*===========================================
summary: 依照 老師帳號 取得 班級ID
remarks: 000 Tim 2021/05/04 Create
===========================================*/
function GetClassIDByTeacher(AccountID, TeacherData)
{
    let intClassID = -1

    if (
        (typeof (TeacherData) !== 'undefined') &&
        (TeacherData !== null) &&
        (typeof (TeacherData.ClassList) !== 'undefined') &&
        (TeacherData.ClassList !== null)
        )
    {
        let blnFound = false
        let intIndex4Class = 0
        let intCount4Class = TeacherData.ClassList.length
        let intIndex4Teacher = 0
        let intCount4Teacher = 0

        while ((!blnFound) && (intIndex4Class < intCount4Class))
        {
            intIndex4Teacher = 0
            intCount4Teacher = TeacherData.ClassList[intIndex4Class].TeacherList.length

            while ((!blnFound) && (intIndex4Teacher < intCount4Teacher))
            {
                if (AccountID === parseInt(TeacherData.ClassList[intIndex4Class].TeacherList[intIndex4Teacher].AccountID))
                {
                    blnFound = true
                    intClassID = parseInt(TeacherData.ClassList[intIndex4Class].ClassID)
                } // end of if
                intIndex4Teacher++
            } // end of while intIndex4Teacher
            intIndex4Class++
        } // end of while intIndex4Class
    } // end of if

    return intClassID
} // end of GetClassIDByTeacher

/*===========================================
summary: 依照 班級ID 取得 班級物件
remarks: 000 Tim 2021/07/26 Create
===========================================*/
function GetClassObjectByClassID(ClassID)
{
    let objClass = null

    if (
        (typeof (window.gSession.Acc.Class) !== 'undefined') &&
        (window.gSession.Acc.Class !== null) &&
        (window.gSession.Acc.Class.length > 0)
        )
    {
        let intIndex = 0
        let intCount = window.gSession.Acc.Class.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (parseInt(ClassID) === parseInt(window.gSession.Acc.Class[intIndex].ClassID))
            {
                blnFound = true
                objClass = window.gSession.Acc.Class[intIndex]
            } // end of if (parseInt(ClassID) === parseInt(window.gSession.Acc.Class[intIndex].ClassID))
        } // end of while   
    } // end of if 

    return objClass
} // end of GetClassObjectByClassID

/*===========================================
summary: 依照 班級ID 取得 BookCategoryID
remarks: 000 Tim 2021/05/04 Create
===========================================*/
function GetBookCategoryIDByClassID(ClassID)
{
    let intBookCategoryID = -1

    if (
        (typeof (window.gSession.Acc.Class) !== 'undefined') &&
        (window.gSession.Acc.Class !== null)
        )
    {
        let blnFound = false
        let intIndex4Class = 0
        let intCount4Class = window.gSession.Acc.Class.length

        while ((!blnFound) && (intIndex4Class < intCount4Class))
        {
            if (parseInt(ClassID) === parseInt(window.gSession.Acc.Class[intIndex4Class].ClassID))
            {
                blnFound = true
                intBookCategoryID = parseInt(window.gSession.Acc.Class[intIndex4Class].CoursePackage[0].BookCategoryID)
            } // end of if
            intIndex4Class++
        } // end of while intIndex4Class
    } // end of if

    return intBookCategoryID
} // end of GetBookCategoryIDByClassID

function GetBookCategoryID(ClassID)
{
    // console.log(COMP_NAME + ".GetBookCategoryID")
    // console.log("GetBookCategoryID: ClassID:", ClassID)
    // console.log("GetBookCategoryID: window.gSession.Acc.Class:", window.gSession.Acc.Class)

    let intBookCategoryID = -1

    if (
        (typeof (window.gSession.Acc.Class) !== 'undefined') &&
        (window.gSession.Acc.Class !== null) &&
        (window.gSession.Acc.Class.length > 0) &&
        (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
        (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage) !== 'undefined') &&
        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage !== null) &&
        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage.length > 0) &&
        (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage[0]) !== 'undefined') &&
        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage[0] !== null) &&
        (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage[0].BookCategoryID) !== 'undefined') &&
        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage[0].BookCategoryID !== null) &&
        (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].CoursePackage[0].BookCategoryID) > 0)
        )
    {
        let blnFound = false
        let intIndex4Class = 0

        while ((!blnFound) && (intIndex4Class < window.gSession.Acc.Class.length))
        {
            if (parseInt(ClassID) === parseInt(window.gSession.Acc.Class[intIndex4Class].ClassID))
            {
                blnFound = true
                intBookCategoryID = parseInt(window.gSession.Acc.Class[intIndex4Class].CoursePackage[0].BookCategoryID)
            } // end of if
            intIndex4Class++
        } // end of while intIndex4Class
    } // end of if
    // console.log(COMP_NAME + ".GetBookCategoryID: intBookCategoryID:", intBookCategoryID)
    return intBookCategoryID
} // end of GetBookCategoryID

/*===========================================
summary: 取得 老師列表 
    param: 

retruns: 
remarks: 000 Tim 2021/05/04 Create
===========================================*/
function GetTeacherList4Class(ClassID)
{
    console.log(COMP_NAME + ".GetTeacherList4Class Acc.TeacherData: ", window.gSession.Acc.TeacherData)

    let arrTeacherList = []
    let intIndex = 0
    let intCount = 0
    let blnFound = false

    if (
        (window.gSession.Acc.TeacherData !== null) &&
        (typeof (window.gSession.Acc.TeacherData.ClassList) !== 'undefined') &&
        (window.gSession.Acc.TeacherData.ClassList !== null) &&
        (window.gSession.Acc.TeacherData.ClassList.length > 0)
        )
    {
        intCount = window.gSession.Acc.TeacherData.ClassList.length
        while ((!blnFound) && (intIndex < intCount))
        {
            if (parseInt(window.gSession.Acc.TeacherData.ClassList[intIndex].ClassID) === parseInt(ClassID))
            {
                blnFound = true
                arrTeacherList = window.gSession.Acc.TeacherData.ClassList[intIndex].TeacherList
            }
            intIndex++
        } // end of while
    }

    return arrTeacherList
} // end of GetTeacherList4Class

/*===========================================
summary: 點選 通知 前往 學生 Class頁面
remarks: 000 Tim 2021/05/05 Create
===========================================*/
function GotoClassOverview4Student4Notification(History, NotificationInfo)
{
    console.log(COMP_NAME + ".GotoClassOverview4Student4Notification")

    let objLocationState = {
        "NotificationInfo": NotificationInfo
    }

    // 學生 Class頁面
    RoutePathLibs.Route2Path(History, "/ClassOverview4Student", objLocationState)
} // end of GotoClassOverview4Student4Notification

function GoToDefaultPage(History)
{
    console.log(COMP_NAME + ".GoToDefaultPage")

    if (parseInt(window.gSession.Acc.ID) > 0)
    {
        // 無論 授權 與 班級 都先進 Home
        RoutePathLibs.Route2Path(History, "/Home") // Production
    }
    else
    {
        // 未登入
        RoutePathLibs.Route2Path(History, "/Login")
    }
}

function GetAccountDisplayPic(PicUrl)
{
    // console.log("GetAccountDisplayPic ", PicUrl)
    let strSrc = ""

    if ((PicUrl === '') || (PicUrl === null))
    {
        // 隨機從多張圖片 選出一張
        // console.log("GetAccountDisplayPic: BIReport.app.gSession.App.DefaultPic:", BIReport.app.gSession.App.DefaultPic)
        // if ((typeof(BIReport.app.gSession.App.DefaultPic.AccountList) !== 'undefined') && (BIReport.app.gSession.App.DefaultPic.AccountList.length > 0))
        // {
        //     let intAccountID = parseInt(AccountID)
        //     let ImageIndex = intAccountID % BIReport.app.gSession.App.DefaultPic.AccountList.length
        //     console.log("GetAccountDisplayPic.ImageIndex:", ImageIndex)

        //     // strSrc = BIReport.app.gConfig.ConfigSettings.BCBackendFileServer + BIReport.app.gSession.App.DefaultPic.AccountList[ImageIndex]
        //     strSrc = 'https://app.betterchinese.com/' + BIReport.app.gSession.App.DefaultPic.AccountList[ImageIndex]
        // }
        // strSrc += window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION
    }
    else
    {
        // strSrc = BIReport.app.gConfig.ConfigSettings.BCBackendFileServer + PicUrl
        strSrc = window.gConfig.BCBackendFileServer + "/" + PicUrl
        strSrc += window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION
    }

    // console.log("GetAccountDisplayPic: strSrc:", strSrc)
    return strSrc
} // end of GetAccountDisplayPic

/*===========================================
summary: 取得 週 名稱
    param: 

retruns: 
remarks: 000 Tim 2021/04/20 Create
===========================================*/
function GetWeekNameByID(WeekID)
{
    let strWeekName = ""

    switch (WeekID)
    {
        case 0:
            strWeekName = window.gAppUI.LBL_Sunday
            break
        case 2:
            strWeekName = window.gAppUI.LBL_Tuesday
            break
        case 3:
            strWeekName = window.gAppUI.LBL_Wednesday
            break
        case 4:
            strWeekName = window.gAppUI.LBL_Thursday
            break
        case 5:
            strWeekName = window.gAppUI.LBL_Friday
            break
        case 6:
            strWeekName = window.gAppUI.LBL_Saturday
            break
        case 1:
        default:
            strWeekName = window.gAppUI.LBL_Monday
            break
    } // end of switch (WeekID)

    return strWeekName
} // end of GetWeekNameByID

/*===========================================
summary: 取得 週 縮寫名稱
    param: 

retruns: 
remarks: 000 Tim 2021/04/21 Create
===========================================*/
function GetWeekAbbreviationByID(WeekID)
{
    let strWeekName = ""

    switch (WeekID)
    {
        case 0:
            strWeekName = window.gAppUI.LBL_Sun
            break
        case 2:
            strWeekName = window.gAppUI.LBL_Tue
            break
        case 3:
            strWeekName = window.gAppUI.LBL_Wed
            break
        case 4:
            strWeekName = window.gAppUI.LBL_Thu
            break
        case 5:
            strWeekName = window.gAppUI.LBL_Fri
            break
        case 6:
            strWeekName = window.gAppUI.LBL_Sat
            break
        case 1:
        default:
            strWeekName = window.gAppUI.LBL_Mon
            break
    } // end of switch (WeekID)

    return strWeekName
} // end of GetWeekAbbreviationByID

// 取得Lesson數字 e.g. Lesson 1, Lesson 2,...    
function GetEnglishLessonNumber(LessonDef, LessonID)
{
    let strPrefixText = ""
    let intIndex = 0
    let intCount = LessonDef.length
    let blnFound = false
    while ((!blnFound) && (intIndex < intCount))
    {
        if (parseInt(LessonDef[intIndex].LessonID) === parseInt(LessonID))
        {
            strPrefixText = LessonDef[intIndex].PrefixText
            blnFound = true
        }
        intIndex++
    } // end of while
    return strPrefixText
} // end of GetEnglishLessonNumber

function GetEnglishLessonNumberAndLessonName(LessonDef, LessonID)
{
    // console.log(COMP_NAME + ".GetEnglishLessonNumberAndLessonName: ", LessonDef, LessonID)
    let strPrefixText = ""
    let strName = ""
    let strResult = ""
    let intIndex = 0
    let intCount = LessonDef.length
    let blnFound = false
    while ((!blnFound) && (intIndex < intCount))
    {
        if (parseInt(LessonDef[intIndex].LessonID) === parseInt(LessonID))
        {
            strPrefixText = LessonDef[intIndex].PrefixText
            strName = LessonDef[intIndex].Name
            blnFound = true
        }
        intIndex++
    } // end of while

    strResult = strPrefixText + " " + strName
    return strResult
}

function GetLUName(SectionSeqNo, SubSectionSeqNo)
{
    // console.log(COMP_NAME + ".GetLUName:")
    // console.log("GetLUName: SectionSeqNo:", SectionSeqNo)
    // console.log("GetLUName: SubSectionSeqNo:", SubSectionSeqNo)
    let intSectionSeqNo = window.gSectionSeqNoType.None
    let intSubSectionSeqNo = window.gSubSectionSeqNoType.None

    if (
        (SectionSeqNo !== null) &&
        (SectionSeqNo !== "")
        )
    {
        intSectionSeqNo = parseInt(SectionSeqNo)
    }

    if (
        (SubSectionSeqNo !== null) &&
        (SubSectionSeqNo !== "")
        )
    {
        intSubSectionSeqNo = parseInt(SubSectionSeqNo)
    }
    // console.log("GetLUName: intSectionSeqNo:", intSectionSeqNo)
    // console.log("GetLUName: intSubSectionSeqNo:", intSubSectionSeqNo)

    let strLUName = ""
    if (
        (intSectionSeqNo === window.gSectionSeqNoType.Lessons) &&
        (
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.Lessons) ||
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.None)
            )
    )
    {
        strLUName = window.gAppUI.LBL_Lessons
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.Learn) &&
        (
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.Learn) ||
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.None)
            )
    )
    {
        strLUName = window.gAppUI.LBL_Learn
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.LessonDialog) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.LessonDialog)
        )
    {
        strLUName = window.gAppUI.LBL_LessonDialog
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.CharacterChallenge1) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.CharacterChallenge1)
        )
    {
        strLUName = window.gAppUI.LBL_CharacterChallenge1
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.CharacterChallenge2) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.CharacterChallenge2)
        )
    {
        strLUName = window.gAppUI.LBL_CharacterChallenge2
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.ReadingChallenge1) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.ReadingChallenge1)
        )
    {
        strLUName = window.gAppUI.LBL_ReadingChallenge1
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.ReadingChallenge2) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.ReadingChallenge2)
        )
    {
        strLUName = window.gAppUI.LBL_ReadingChallenge2
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.ChildrenSong) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.ChildrenSong)
        )
    {
        strLUName = window.gAppUI.LBL_ChildrenSong
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.Rhyme) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.Rhyme)
        )
    {
        strLUName = window.gAppUI.LBL_Rhyme
    }

    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.Expression) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.Expression)
        )
    {
        strLUName = window.gAppUI.LBL_Expression
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.Vocabularies) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.Vocabularies)
        )
    {
        strLUName = window.gAppUI.LBL_Vocabularies
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.FoundationCharacters) &&
        (intSubSectionSeqNo === window.gSubSectionSeqNoType.FoundationCharacters)
        )
    {
        strLUName = window.gAppUI.LBL_FoundationCharacters
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.Practice) &&
        (
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.Practice) ||
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.None)
            )
    )
    {
        strLUName = window.gAppUI.LBL_Practice
    }
    else if (
        (intSectionSeqNo === window.gSectionSeqNoType.Stories) &&
        (
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.Stories) ||
            (intSubSectionSeqNo === window.gSubSectionSeqNoType.None)
            )
    )
    {
        strLUName = window.gAppUI.LBL_Stories
    }

    // console.log("GetLUName: strLUName:", strLUName)

    return strLUName
}

// function GeneratePreferenceKeyValue(Key, Value)
// {
//     let objPref = {
//         "Key": Key,
//         "Value": Value
//     }
//     return objPref
// }

// Richard： 建議用 prototype.PadLeft
function PadValueWithZero(value)
{
    // console.log("PadValueWithZero: value:", value)
    let intValue = parseInt(value)
    // console.log("PadValueWithZero: intValue:", intValue)
    let strValue = (intValue < 10) ? "0" + intValue.toString() : intValue.toString()
    // console.log("PadValueWithZero: strValue:", strValue)
    return strValue
}

function GetDateWithFormat(DateValue, ReturnDateOnly = window.gDateTimeFormatEnum.DateOnly)
{
    // console.log(COMP_NAME + ".GetDateWithFormat: ReturnDateOnly:", ReturnDateOnly)
    // console.log(COMP_NAME + ".GetDateWithFormat: DateValue:", DateValue)

    DateValue = DateValue.replace(/-/g, '/') // Safari 只能吃斜線的時間格式 2021/05/04, Chrome 可吃2021/05/04及2021-05-04
    // console.log(COMP_NAME + ".GetFormatDate: DateValue:", DateValue)
    let newDate = new Date(DateValue)
    // console.log(COMP_NAME + ".newDate:", newDate)
    let intMonth = newDate.getMonth() + 1
    let strMonthWithZero = PadValueWithZero(newDate.getMonth() + 1)
    let intDay = newDate.getDate()
    let strDayWithZero = PadValueWithZero(newDate.getDate())
    let intYear = newDate.getFullYear()
    let intHour = newDate.getHours()
    let intMinute = newDate.getMinutes()
    let strMinuteWithZero = PadValueWithZero(newDate.getMinutes())
    let strSecondWithZero = PadValueWithZero(newDate.getSeconds())

    // console.log("strMonthWithZero:", strMonthWithZero)
    // console.log("strDayWithZero:", strDayWithZero)
    // console.log("intYear:", intYear)
    // console.log("intHour:", intHour)
    // console.log("intMinute:", intHour)
    // console.log("strMinuteWithZero:", strMinuteWithZero)
    // console.log("strSecondWithZero:", strSecondWithZero)

    let arrWeekday = new Array(7)
    arrWeekday[0] = "Sunday"
    arrWeekday[1] = "Monday"
    arrWeekday[2] = "Tuesday"
    arrWeekday[3] = "Wednesday"
    arrWeekday[4] = "Thursday"
    arrWeekday[5] = "Friday"
    arrWeekday[6] = "Saturday"
    let strWeekDay = arrWeekday[newDate.getDay()]
    // console.log("strWeekDay:", strWeekDay)

    let strAmPm = ""

    let intHourForAmPm = -1
    let intHourCheck = parseInt(intHour)
    // console.log("intHourCheck:", intHourCheck)

    if (intHourCheck > 12)
    {
        strAmPm = "pm"
        intHourForAmPm = intHourCheck - 12
    }
    else if (intHourCheck < 12)
    {
        intHourForAmPm = intHour
        strAmPm = "am"
    }
    else if (intHourCheck === 12)
    {
        intHourForAmPm = 12
        strAmPm = "pm"
    }
    else if (intHourCheck === 0)
    {
        intHourForAmPm = 12
        strAmPm = "am"
    }
    // console.log("intHourForAmPm:", intHourForAmPm)
    let strHourForAmPm = PadValueWithZero(intHourForAmPm)
    let strHourWithZero = PadValueWithZero(intHour)
    // console.log("strHourForAmPm:", strHourForAmPm)
    // console.log("strHourWithZero:", strHourWithZero)

    let strResultDateTime = ""
    if (ReturnDateOnly === window.gDateTimeFormatEnum.DateOnly)
    {
        strResultDateTime = intYear + "/" + strMonthWithZero + "/" + strDayWithZero
    }
    if (ReturnDateOnly === window.gDateTimeFormatEnum.MonthDay)
    {
        strResultDateTime = intMonth + "/" + intDay
    }
    else if (ReturnDateOnly === window.gDateTimeFormatEnum.TimeOnly)
    {
        strResultDateTime = strHourWithZero + ":" + strMinuteWithZero + ":" + strSecondWithZero
    }
    else if (ReturnDateOnly === window.gDateTimeFormatEnum.DateAndTime)
    {
        strResultDateTime = intYear + "/" + strMonthWithZero + "/" + strDayWithZero + " " + strHourWithZero + ":" + strMinuteWithZero + ":" + strSecondWithZero
    }
    else if (ReturnDateOnly === window.gDateTimeFormatEnum.DateAndTimeWithAmPm)
    {
        strResultDateTime = intYear + "/" + strMonthWithZero + "/" + strDayWithZero + " " + strHourForAmPm + ":" + intMinute + strAmPm
    }
    else if (ReturnDateOnly === window.gDateTimeFormatEnum.TimeOnlyWithAmPm)
    {
        strResultDateTime = strHourForAmPm + ":" + strMinuteWithZero + strAmPm
    }
    else if (ReturnDateOnly === window.gDateTimeFormatEnum.Weekday)
    {
        strResultDateTime = strWeekDay
    }

    // console.log(COMP_NAME + ".strResultDateTime:", strResultDateTime)
    return strResultDateTime
}

// 取得Lesson Name e.g. Hello!, What's your name?, ... 
function GetLessonIndex(LessonDef, LessonID)
{
    console.log(COMP_NAME + ".GetLessonIndex:", LessonDef, LessonID)
    let intLessonIndex = -1

    for (let idx = 0; idx < LessonDef.length; idx++)
    {
        if (LessonDef[idx].LessonID === LessonID)
        {
            intLessonIndex = idx
            break
        }
    }

    return intLessonIndex
}

// /*===========================================
// summary: 秒數 轉換 為 時間物件
// remarks: 000 Richard 2021/06/24 Create  Tim幫忙搬移、註解
// ===========================================*/
// function ConvertSeconds2TimeObject(Seconds)
// {
//     console.log("ConvertSeconds2TimeObject: ", Seconds)

//     let intHours = parseInt(Seconds / 3600)
//     let intRemainingSeconds = Seconds % 3600

//     let intMinutes = parseInt(intRemainingSeconds / 60)
//     let intSeconds = intRemainingSeconds % 60

//     let objTime = {
//         "Hour": intHours,
//         "Minute": intMinutes,
//         "Second": intSeconds
//     }

//     console.log("objTime: ", objTime)
//     return objTime
// } // end of ConvertSeconds2TimeObject

// /*===========================================
// summary: 時間文字 轉換為 秒數
// remarks: 000 Richard 2021/06/24 Create  Tim幫忙搬移、註解
// ===========================================*/
// function ConvertTimeString2Seconds(TimeString)
// {
//     console.log("ConvertTimeString2Seconds: ", TimeString)

//     let arrTime = TimeString.split(":")
//     console.log("arrTime: ", arrTime)
//     let intSeconds = parseInt(arrTime[0]) * 60 * 60 + parseInt(arrTime[1]) * 60 + parseInt(arrTime[2])

//     return intSeconds
// } // end of ConvertTimeString2Seconds

// /*===========================================
// summary: 學生預約資料 系統時間 轉換為 本地時間
// remarks: 000 Tim 2021/06/29 Create
// ===========================================*/
// function ConvertServerDayTime2LocalDayTime4Schedule(ScheduledDate, StartTimeString, EndTimeString)
// {
//     console.log("ConvertServerDayTime2LocalDayTime4Schedule: ", ScheduledDate, StartTimeString, EndTimeString)

//     // EndTime: "00:30:00"
//     // ScheduledDate: "2021-07-02"
//     // StartTime: "00:15:00"

//     // get current Timezone offset
//     let intTimezoneOffset = new Date().getTimezoneOffset()
//     console.log("intTimezoneOffset: ", intTimezoneOffset)

//     let datScheduled = new Date(ScheduledDate.replace(/-/g, '/') + " 00:00:00")

//     let objOfficeHour = {
//         "ScheduledDate": "",
//         "StartTimeString": StartTimeString,
//         "EndTimeString": EndTimeString
//     }

//     if (intTimezoneOffset !== 0)
//     {
//         // let blnNeedToAddTime = (intTimezoneOffset < 0) ? true : false
//         let intTimezoneOffsetSeconds = intTimezoneOffset * 60

//         let intSeconds4Start = ConvertTimeString2Seconds(StartTimeString)
//         console.log("intSeconds4Start: ", intSeconds4Start)
//         let intConvertedSeconds4Start = intSeconds4Start - intTimezoneOffsetSeconds
//         console.log("intTimezoneOffsetSeconds: ", intTimezoneOffsetSeconds)
//         console.log("intConvertedSeconds4Start: ", intConvertedSeconds4Start)

//         let intSeconds4End = ConvertTimeString2Seconds(EndTimeString)
//         console.log("intSeconds4End: ", intSeconds4End)
//         let intConvertedSeconds4End = intSeconds4End - intTimezoneOffsetSeconds
//         console.log("intConvertedSeconds4End: ", intConvertedSeconds4End)

//         let intSecondsInOneDay = 24 * 60 * 60

//         if (intConvertedSeconds4Start >= intSecondsInOneDay)
//         {
//             datScheduled = datScheduled.setDate(datScheduled.getDate() + 1)

//             intConvertedSeconds4Start -= intSecondsInOneDay
//             intConvertedSeconds4End -= intSecondsInOneDay
//         }
//         else if (intConvertedSeconds4Start < 0)
//         {
//             datScheduled = datScheduled.setDate(datScheduled.getDate() - 1)

//             intConvertedSeconds4Start += intSecondsInOneDay
//             intConvertedSeconds4End += intSecondsInOneDay
//         }

//         datScheduled = new Date(datScheduled)
//         objOfficeHour.ScheduledDate = datScheduled.FormateBCDisplayDate()

//         let objTime4Start = ConvertSeconds2TimeObject(intConvertedSeconds4Start)
//         let objTime4End = ConvertSeconds2TimeObject(intConvertedSeconds4End)
//         console.log("objTime4Start: ", objTime4Start)
//         console.log("objTime4End: ", objTime4End)

//         objOfficeHour.StartTimeString = objTime4Start.Hour.toString().PadLeft(2) + ":" + objTime4Start.Minute.toString().PadLeft(2) + ":" + objTime4Start.Second.toString().PadLeft(2)
//         objOfficeHour.EndTimeString = objTime4End.Hour.toString().PadLeft(2) + ":" + objTime4End.Minute.toString().PadLeft(2) + ":" + objTime4End.Second.toString().PadLeft(2)
//     }

//     console.log("objOfficeHour Before: ", ScheduledDate, StartTimeString, EndTimeString)
//     console.log("objOfficeHour After: ", objOfficeHour)
//     return objOfficeHour
// } // end of ConvertServerDayTime2LocalDayTime4Schedule

// /*===========================================
// summary: 預約資料 本地時間 轉換為 系統時間
// remarks: 000 Tim 2021/06/29 Create
// ===========================================*/
// function ConvertLocalDayTime2ServerDayTime(ScheduledDate, StartTimeString, EndTimeString)
// {
//     console.log("ConvertLocalDayTime2ServerDayTime: ", ScheduledDate, StartTimeString, EndTimeString)

//     // EndTime: "00:30:00"
//     // ScheduledDate: "2021-07-02"
//     // StartTime: "00:15:00"

//     // get current Timezone offset
//     let intTimezoneOffset = new Date().getTimezoneOffset()
//     console.log("intTimezoneOffset: ", intTimezoneOffset)

//     let datScheduled = new Date(ScheduledDate.replace(/-/g, '/') + " 00:00:00")

//     let objOfficeHour = {
//         "ScheduledDate": "",
//         "StartTimeString": StartTimeString,
//         "EndTimeString": EndTimeString
//     }

//     if (intTimezoneOffset !== 0)
//     {
//         // let blnNeedToAddTime = (intTimezoneOffset < 0) ? true : false
//         let intTimezoneOffsetSeconds = intTimezoneOffset * 60

//         let intSeconds4Start = ConvertTimeString2Seconds(StartTimeString)
//         console.log("intSeconds4Start: ", intSeconds4Start)
//         let intConvertedSeconds4Start = intSeconds4Start + intTimezoneOffsetSeconds
//         console.log("intTimezoneOffsetSeconds: ", intTimezoneOffsetSeconds)
//         console.log("intConvertedSeconds4Start: ", intConvertedSeconds4Start)

//         let intSeconds4End = ConvertTimeString2Seconds(EndTimeString)
//         console.log("intSeconds4End: ", intSeconds4End)
//         let intConvertedSeconds4End = intSeconds4End + intTimezoneOffsetSeconds
//         console.log("intConvertedSeconds4End: ", intConvertedSeconds4End)

//         let intSecondsInOneDay = 24 * 60 * 60

//         if (intConvertedSeconds4Start >= intSecondsInOneDay)
//         {
//             datScheduled = datScheduled.setDate(datScheduled.getDate() + 1)

//             intConvertedSeconds4Start -= intSecondsInOneDay
//             intConvertedSeconds4End -= intSecondsInOneDay
//         }
//         else if (intConvertedSeconds4Start < 0)
//         {
//             datScheduled = datScheduled.setDate(datScheduled.getDate() - 1)

//             intConvertedSeconds4Start += intSecondsInOneDay
//             intConvertedSeconds4End += intSecondsInOneDay
//         }

//         datScheduled = new Date(datScheduled)
//         objOfficeHour.ScheduledDate = datScheduled.FormateBCDisplayDate()

//         let objTime4Start = ConvertSeconds2TimeObject(intConvertedSeconds4Start)
//         let objTime4End = ConvertSeconds2TimeObject(intConvertedSeconds4End)
//         console.log("objTime4Start: ", objTime4Start)
//         console.log("objTime4End: ", objTime4End)

//         objOfficeHour.StartTimeString = objTime4Start.Hour.toString().PadLeft(2) + ":" + objTime4Start.Minute.toString().PadLeft(2) + ":" + objTime4Start.Second.toString().PadLeft(2)
//         objOfficeHour.EndTimeString = objTime4End.Hour.toString().PadLeft(2) + ":" + objTime4End.Minute.toString().PadLeft(2) + ":" + objTime4End.Second.toString().PadLeft(2)
//     }

//     console.log("objOfficeHour Before: ", ScheduledDate, StartTimeString, EndTimeString)
//     console.log("objOfficeHour After: ", objOfficeHour)
//     return objOfficeHour
// } // end of ConvertLocalDayTime2ServerDayTime

// /*===========================================
// summary: 取得 顯示 時間區段
// remarks: 000 Tim 2021/07/25 Create
// ===========================================*/
// function GetTimeSegmentDisplayString(StartTime, EndTime, SelectedDate)
// {
//     let strSelectedDate = ""
//     if (
//         (typeof (SelectedDate) !== 'undefined') &&
//         (SelectedDate !== null) &&
//         (SelectedDate !== "")
//         )
//     {
//         strSelectedDate = SelectedDate
//     }

//     let datStartTime = StartTime.ToUTC()
//     let datEndTime = EndTime.ToUTC()

//     let strStartTimeLocal = datStartTime.ToBCLocalTimeString()
//     let strEndTimeLocal = datEndTime.ToBCLocalTimeString()

//     let arrStart = strStartTimeLocal.split(" ")
//     let arrEnd = strEndTimeLocal.split(" ")

//     let strStartDate = arrStart[0]
//     let strEndDate = arrEnd[0]
//     let strStartTime = window.Globals.GetScheduleDisplayTime(arrStart[1])
//     let strEndTime = window.Globals.GetScheduleDisplayTime(arrEnd[1])

//     let strTimeSegment = ""
//     let arrDate = []
//     let strDate = ""

//     // console.log("================== GetTimeSegmentDisplayString ==================")
//     // console.log("GetTimeSegmentDisplayString strSelectedDate: ", strSelectedDate)
//     // console.log("GetTimeSegmentDisplayString strStartDate: ", strStartDate)
//     // console.log("GetTimeSegmentDisplayString strEndDate: ", strEndDate)
//     // console.log("GetTimeSegmentDisplayString strStartTimeLocal: ", strStartTimeLocal)
//     // console.log("GetTimeSegmentDisplayString strEndTimeLocal: ", strEndTimeLocal)
//     // console.log("GetTimeSegmentDisplayString strStartTime: ", strStartTime)
//     // console.log("GetTimeSegmentDisplayString strEndTime: ", strEndTime)

//     if (
//         (strSelectedDate !== "") &&
//         (strStartDate === strEndDate) &&
//         (strStartDate !== strSelectedDate)
//         )
//     {
//         // console.log("GetTimeSegmentDisplayString 1 strSelectedDate: ", strSelectedDate)
//         // SelectedDate: 07/30
//         // Start: 07/29 23:00 ~ 23:15
//         arrDate = strStartDate.split("-")
//         strDate = arrDate[1] + "/" + arrDate[2]
//         strTimeSegment = strDate + " " + strStartTime + " - " + strEndTime
//     }
//     else if (strStartDate === strEndDate)
//     {
//         // console.log("GetTimeSegmentDisplayString 2 strStartDate: ", strStartDate)

//         strTimeSegment = strStartTime + " - " + strEndTime
//     }
//     else if (strStartDate === strSelectedDate)
//     {
//         // console.log("GetTimeSegmentDisplayString 3 strSelectedDate: ", strSelectedDate)
//         arrDate = strEndDate.split("-")
//         strDate = arrDate[1] + "/" + arrDate[2]
//         strTimeSegment = strStartTime + " - " + strDate + " " + strEndTime
//     }
//     else if (strEndDate === strSelectedDate)
//     {
//         // console.log("GetTimeSegmentDisplayString 4 strSelectedDate: ", strSelectedDate)
//         arrDate = strStartDate.split("-")
//         strDate = arrDate[1] + "/" + arrDate[2]
//         strTimeSegment = strDate + " " + strStartTime + " - " + strEndTime
//     }

//     return strTimeSegment
// } // end of GetTimeSegmentDisplayString

/*===========================================
summary: 取得 通知取消 說明訊息 提示物件
remarks: 001 Tim 2021/07/26 Create
===========================================*/
// function GetNotificationCancelAlertObject(StartTime, EndTime, FirstName, LastName, LoginName)
// {
//     // 點擊後續動作 Tim 製作的      Tim21.07.25
//     // 點擊後轉跳：說明訊息視窗
//     // let datDate = new Date(StartTime.replace(/-/g, '/'))

//     // 先轉 Local 時間
//     let datDate = StartTime.ToUTC()
//     let strStartTimeLocal = datDate.ToBCLocalTimeString()

//     let strDate = strStartTimeLocal.split(" ")[0]
//     let strTimeSegment = GetTimeSegmentDisplayString(StartTime, EndTime, strDate)

//     let intWeekID = datDate.getDay()
//     let strWeekName = GetWeekAbbreviationByID(intWeekID)

//     let strUserName = window.Globals.FormateDisplayName(FirstName, LastName, LoginName)

//     let strMessage = window.gAppUI.MSG_MessageMeetingCancelMessage + "\n"
//     strMessage = strMessage.replace("@UserName@", strUserName)
//     strMessage += strWeekName + ", " + strDate.replace(/-/g, '/') + ", " + strTimeSegment

//     let objAlertObject = {
//         Header: window.gAppUI.MSG_MessageMeetingCancelTitle,
//         Body: strMessage,
//         CallbackRef: null,
//         Buttons: [{
//             Text: PackageVariablesLibs.UISettings.BTN_OK,
//             AutoFocus: true
//         }]
//     }

//     return objAlertObject
// } // end of GetNotificationCancelAlertObject

// function GetTimeFormatHHMMSS(DurationSeconds)
// {
//     let intDurationSeconds = parseInt(DurationSeconds)
//     let strResult = "--"
//     if (
//         (DurationSeconds !== null) &&
//         (intDurationSeconds >= 0)
//         )
//     {
//         // Method I
//         // let date = new Date(null)
//         // date.setSeconds(intDurationSeconds)
//         // strResult = date.toISOString().substr(11, 8)
//         // Method II
//         let intHours = Math.floor(intDurationSeconds / 3600)
//         intDurationSeconds %= 3600
//         let intMinutes = Math.floor(intDurationSeconds / 60)
//         let intSeconds = intDurationSeconds % 60
//         let strHours = (intHours < 10) ? "0" + intHours : intHours
//         let strMinutes = (intMinutes < 10) ? "0" + intMinutes : intMinutes
//         let strSeconds = (intSeconds < 10) ? "0" + intSeconds : intSeconds
//         strResult = strHours + ":" + strMinutes + ":" + strSeconds
//     }
//     return strResult
// }

// // Notification Item 顯示的文字
// function GetFormatNotificationMessage(NotificationInfo)
// {
//     console.log("GetFormatNotificationMessage: NotificationInfo:", NotificationInfo)
//     let strResult = ""
//     let intNotificationType = parseInt(NotificationInfo.NotificationType)
//     if (intNotificationType === window.gNotificationTypeEnum.Bulletin)
//     {
//         let strNameSender = window.Globals.FormateDisplayName(NotificationInfo.FirstName, NotificationInfo.LastName, NotificationInfo.LoginName)
//         // As of August 2020: Modern browsers have support for the String.replaceAll() method defined by the ECMAScript 2021 language specification.
//         // Ref: https://stackoverflow.com/questions/1144783/how-to-replace-all-occurrences-of-a-string-in-javascript
//         // 公司的Chromebook 不支援 function replaceAll
//         // let strMessage = NotificationInfo.Message.replaceAll("<br />", " ") // 移除斷行
//         let strMessage = NotificationInfo.Message.replace(/<br \/>/g, " ") // 移除斷行
//         strResult = strNameSender + " : " + strMessage
//     }
//     else if (intNotificationType === window.gNotificationTypeEnum.Assignment)
//     {
//         let strNameSender = window.Globals.FormateDisplayName(NotificationInfo.FirstName, NotificationInfo.LastName, NotificationInfo.LoginName)

//         if (
//             (NotificationInfo.Message !== null) &&
//             (NotificationInfo.Message !== "")
//             )
//         {
//             // 老師有寫 Message
//             let strMessage = NotificationInfo.Message.replace(/<br \/>/g, " ") // 移除斷行
//             strResult = strNameSender + " : " + strMessage
//         }
//         else
//         {
//             // 老師沒寫 Message
//             let strLessonNumberAndLessonName = window.Globals.GetEnglishLessonNumberAndLessonName(window.gSession.App.LessonDef, NotificationInfo.LessonID)
//             // let strLessonNumberAndLessonName = GetLessonName(NotificationInfo.LessonID)
//             let strMessageSidebarNotification = strLessonNumberAndLessonName + " : " + window.Globals.GetLUName(NotificationInfo.SectionSeqNo, NotificationInfo.SubSectionSeqNo)

//             strResult = strNameSender + " " + window.gAppUI.LBL_ToastWasAssignANewAssignment + " : " + strMessageSidebarNotification
//         }
//     }
//     else if (intNotificationType === window.gNotificationTypeEnum.Meeting)
//     {

//         let strNameSender = window.Globals.FormateDisplayName(NotificationInfo.FirstName, NotificationInfo.LastName, NotificationInfo.LoginName)
//         // console.log("NotificationInfo.StartTime:", NotificationInfo.StartTime)
//         // console.log("NotificationInfo.EndTime:", NotificationInfo.EndTime)
//         let objDateStartTime = NotificationInfo.StartTime.ToUTC()
//         let objDateEndTime = NotificationInfo.EndTime.ToUTC()
//         // console.log("objDateStartTime:", objDateStartTime)
//         // console.log("objDateEndTime:", objDateEndTime)

//         let strStartTimeTimeOnlyWithAmPm = window.Globals.GetDateWithFormat(objDateStartTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.TimeOnlyWithAmPm)
//         let strEndTimeTimeOnlyWithAmPm = window.Globals.GetDateWithFormat(objDateEndTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.TimeOnlyWithAmPm)
//         // console.log("strStartTimeTimeOnlyWithAmPm:", strStartTimeTimeOnlyWithAmPm)
//         // console.log("strEndTimeTimeOnlyWithAmPm:", strEndTimeTimeOnlyWithAmPm)
//         let strStartTimeMMDD = window.Globals.GetDateWithFormat(objDateStartTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.MonthDay)
//         let strEndTimeMMDD = window.Globals.GetDateWithFormat(objDateEndTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.MonthDay)
//         // console.log("strStartTimeMMDD:", strStartTimeMMDD)
//         // console.log("strEndTimeMMDD:", strEndTimeMMDD)

//         let strStartTimeWithYYYYMMDD = window.Globals.GetDateWithFormat(objDateStartTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.DateOnly)
//         let strEndTimeWithYYYYMMDD = window.Globals.GetDateWithFormat(objDateEndTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.DateOnly)
//         let strStartTimeWeekday = window.Globals.GetDateWithFormat(objDateStartTime.ToBCLocalTimeString(), window.gDateTimeFormatEnum.Weekday)
//         // console.log("strStartTimeWithYYYYMMDD:", strStartTimeWithYYYYMMDD)
//         // console.log("strEndTimeWithYYYYMMDD:", strEndTimeWithYYYYMMDD)
//         // console.log("strStartTimeWeekday:", strStartTimeWeekday)

//         // console.log("GetFormatNotificationMessage: NotificationInfo.EventType:", NotificationInfo.EventType)
//         let intEventType = parseInt(NotificationInfo.EventType)
//         if (intEventType === window.gMeetingEventType.StudentBooking1on1)
//         {
//             // 學生預約1on1
//             strResult = strNameSender + " " + window.gAppUI.LBL_ToastWantToAppoint1on1ScheduleOn + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             // console.log("GetFormatNotificationMessage: StudentBooking1on1 strResult:", strResult)
//         }
//         else if (intEventType === window.gMeetingEventType.TeacherApproveStudentBooking)
//         {
//             // 老師同意學生的預約
//             strResult = strNameSender + " " + window.gAppUI.LBL_ToastAgreedYour1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             // console.log("GetFormatNotificationMessage: TeacherApproveStudentBooking strResult:", strResult)
//         }
//         else if (intEventType === window.gMeetingEventType.TeacherCancelOrStudentCancleBeforeTeacherResponse)
//         {
//             // 老師未同意 老師取消 學生的預約 / 老師未同意 學生取消預約
//             // 老師/學生 都用相同的通知訊息
//             strResult = strNameSender + " " + window.gAppUI.LBL_ToastCanceled1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             // console.log("GetFormatNotificationMessage: TeacherCancelOrStudentCancleBeforeTeacherResponse strResult:", strResult)

//             // let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)
//             // if(intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
//             // {
//             //     // 我是學生 收到老師的取消 顯示通知
//             //     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCanceled1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             //     console.log("GetFormatNotificationMessage: TeacherCancelOrStudentCancleBeforeTeacherResponse I'm Student strResult:", strResult)
//             // }
//             // else if(intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
//             // {
//             //     // 我是老師 收到老師的取消 顯示通知
//             //     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCanceled1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             //     console.log("GetFormatNotificationMessage: TeacherCancelOrStudentCancleBeforeTeacherResponse I'm Teacher strResult:", strResult)
//             // }

//         }
//         else if (intEventType === window.gMeetingEventType.TeacherCancelOrStudentCancelAfterTeacherApprove)
//         {
//             // 老師已同意後 老師取消 學生的預約 / 老師已同意後 學生取消預約
//             // 老師/學生 都用相同的通知訊息
//             strResult = strNameSender + " " + window.gAppUI.LBL_ToastCanceled1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm

//             // let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)
//             // if(intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
//             // {
//             //     // 我是學生 收到老師的取消 顯示通知
//             //     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCanceled1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             //     console.log("GetFormatNotificationMessage: TeacherApproveStudentBooking I'm Student strResult:", strResult)
//             // }
//             // else if(intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
//             // {
//             //     // 我是老師 收到老師的取消 顯示通知
//             //     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCanceled1on1ScheduleOn + " " + strStartTimeMMDD + ", " + strStartTimeTimeOnlyWithAmPm
//             //     console.log("GetFormatNotificationMessage: TeacherApproveStudentBooking I'm Teacher strResult:", strResult)
//             // }

//         }
//         else if (intEventType === window.gMeetingEventType.TeacherCreate1on1)
//         {
//             // 目前只有New 所以不區分
//             // let intActionType = parseInt(NotificationInfo.ActionType)
//             // if(intActionType === window.gMeetingEditActionTypeEnum.New)
//             // {
//             let intMeetingRepeatType = parseInt(NotificationInfo.RepeatType)
//             // 老師建立1on1
//             if (intMeetingRepeatType === window.gMeetingRepeatTypeEnum.NoRepeat) // 不要重複
//             {
//                 // 開始跟結束日期(YYYY-mm-DD)不一樣
//                 if (strStartTimeWithYYYYMMDD === strEndTimeWithYYYYMMDD)
//                 {
//                     // Local Time 開始跟結束的日期(YYYY-mm-DD)一樣
//                     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCreatedA1on1Schedule + " : " + strStartTimeMMDD + " " + strStartTimeTimeOnlyWithAmPm + "-" + strEndTimeTimeOnlyWithAmPm
//                     // console.log("GetFormatNotificationMessage: Local Time 開始跟結束的日期(YYYY-mm-DD)一樣) strResult:", strResult)
//                 }
//                 else
//                 {
//                     // Local Time 開始跟結束的日期(YYYY-mm-DD)不一樣
//                     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCreatedA1on1Schedule + " : " + strStartTimeMMDD + " " + strStartTimeTimeOnlyWithAmPm + "-" + strEndTimeMMDD + " " + strEndTimeTimeOnlyWithAmPm
//                     // console.log("GetFormatNotificationMessage: Local Time 開始跟結束的日期(YYYY-mm-DD)不一樣 | 不要重複 strResult:", strResult)
//                 }
//             }
//             else if (
//                 (intMeetingRepeatType === window.gMeetingRepeatTypeEnum.RepeatTime) || // 重複N次  2~8
//                 (intMeetingRepeatType === window.gMeetingRepeatTypeEnum.RepeatEndAt) // 重複 到哪天
//             )
//             {
//                 // Local Time 開始跟結束的日期(YYYY-mm-DD)不一樣
//                 strResult = strNameSender + " " + window.gAppUI.LBL_ToastCreatedA1on1Schedule + " : " + window.gAppUI.LBL_Every + " " + strStartTimeWeekday + " " + strStartTimeTimeOnlyWithAmPm + "-" + strEndTimeTimeOnlyWithAmPm
//                 // console.log("GetFormatNotificationMessage: 重複 strResult:", strResult)
//             }
//             // }
//             // else if(intActionType === window.gMeetingEditActionTypeEnum.Update)
//             // {
//             //     // 老師更新1 on 1
//             // }
//             // else if(intActionType === window.gMeetingEditActionTypeEnum.Delete)
//             // {
//             //     // 老師刪除1 on 1
//             // }
//         }
//         else if (intEventType === window.gMeetingEventType.TeacherCreateOfficeHour)
//         {
//             // 目前只有New 所以不區分
//             // let intActionType = parseInt(NotificationInfo.ActionType)
//             // if(intActionType === window.gMeetingEditActionTypeEnum.New)
//             // {
//             let intMeetingRepeatType = parseInt(NotificationInfo.RepeatType)
//             // 老師建立Office Hour
//             if (intMeetingRepeatType === window.gMeetingRepeatTypeEnum.NoRepeat) // 不要重複
//             {

//                 // 開始跟結束日期(YYYY-mm-DD)不一樣
//                 if (strStartTimeWithYYYYMMDD === strEndTimeWithYYYYMMDD)
//                 {
//                     // "Teacher Info" was create a new office hours：[ShowDate]”Month/Date/StartTime-EndTime”
//                     // Local Time 開始跟結束的日期(YYYY-mm-DD)一樣
//                     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCreatedAOfficeHours + " : " + strStartTimeMMDD + " " + strStartTimeTimeOnlyWithAmPm + "-" + strEndTimeTimeOnlyWithAmPm
//                     // console.log("GetFormatNotificationMessage: Local Time 開始跟結束的日期(YYYY-mm-DD)一樣) strResult:", strResult)
//                 }
//                 else
//                 {
//                     // "Teacher Info" was create a new office hours：[ShowDate]”Month/Date/StartTime-Month/Date/EndTime”
//                     // Local Time 開始跟結束的日期(YYYY-mm-DD)不一樣

//                     strResult = strNameSender + " " + window.gAppUI.LBL_ToastCreatedAOfficeHours + " : " + strStartTimeMMDD + " " + strStartTimeTimeOnlyWithAmPm + "-" + strEndTimeMMDD + " " + strEndTimeTimeOnlyWithAmPm
//                     // console.log("GetFormatNotificationMessage: Local Time 開始跟結束的日期(YYYY-mm-DD)不一樣 | 不要重複: strResult:", strResult)
//                 }
//             }
//             else if (
//                 (intMeetingRepeatType === window.gMeetingRepeatTypeEnum.RepeatTime) || // 重複N次  2~8
//                 (intMeetingRepeatType === window.gMeetingRepeatTypeEnum.RepeatEndAt) // 重複 到哪天
//             )
//             {
//                 // Local Time 開始跟結束的日期(YYYY-mm-DD)不一樣
//                 strResult = strNameSender + " " + window.gAppUI.LBL_ToastCreatedAOfficeHours + " : " + window.gAppUI.LBL_Every + " " + strStartTimeWeekday + " " + strStartTimeTimeOnlyWithAmPm + "-" + strEndTimeTimeOnlyWithAmPm
//                 // console.log("GetFormatNotificationMessage: 重複 strResult:", strResult)
//             }
//             // }
//             // else if(intActionType === window.gMeetingEditActionTypeEnum.Update)
//             // {
//             //     // 老師更新Office Hour
//             // }
//             // else if(intActionType === window.gMeetingEditActionTypeEnum.Delete)
//             // {
//             //     // 老師刪除Office Hour
//             // }   
//         }
//     }
//     // console.log("GetFormatNotificationMessage: strResult:", strResult)
//     return strResult
// }

// function GetNotificationIndexInNotificationList(NotificationID)
// {
//     console.log(COMP_NAME + ".GetNotificationIndexInNotificationList: ", NotificationID)
//     let i = 0
//     let intNotificationIndex = -1
//     let blnFound = false
//     while (
//         window.gSession.Acc.NotificationList.length > 0 &&
//         !blnFound &&
//         i < window.gSession.Acc.NotificationList.length
//     )
//     {
//         if (window.gSession.Acc.NotificationList[i].NotificationID === NotificationID)
//         {
//             intNotificationIndex = i
//             blnFound = true
//         }
//         i++
//     }
//     return intNotificationIndex
// }

/*===========================================
summary: 取得 LearningUnit 暫存資料
remarks: 000 Tim 2021/08/31 Create
===========================================*/
// function GetLearningUnitCacheIndex(LessonID, LUType)
// {
//     let intIndex4Out = 0
//     let blnFound = false
//     let intIndex = 0
//     let intCount = window.gSession.Acc.LearningUnitCacheList.length

//     while ((!blnFound) && (intIndex < intCount))
//     {
//         if (
//             (parseInt(LessonID) === parseInt(window.gSession.Acc.LearningUnitCacheList[intIndex].LessonID)) &&
//             (parseInt(LUType) === parseInt(window.gSession.Acc.LearningUnitCacheList[intIndex].LUType))
//             )
//         {
//             blnFound = true
//             intIndex4Out = intIndex
//         } // end of if
//         intIndex++
//     } // end of while intIndex

//     if (!blnFound)
//     {
//         let objLearningUnitCache = {
//             "LessonID": parseInt(LessonID),
//             "LUType": parseInt(LUType)
//         }

//         window.gSession.Acc.LearningUnitCacheList.push(objLearningUnitCache)

//         intIndex4Out = window.gSession.Acc.LearningUnitCacheList.length - 1
//     }

//     return intIndex4Out
// } // end of GetLearningUnitCacheIndex

/*===========================================
summary: 建立 GoogleClassroom Share 的 Url
  param: 

retruns: 
remarks: 000 Tim 2021/01/13 Create
===========================================*/
function GenerateShare2GoogleClassroomUrl(LUCatSeqNo)
{
    console.log(COMP_NAME + '.GenerateShare2GoogleClassroomUrl');

    console.log("gSession.App.CurrentLesson: ", window.gSession.App.CurrentLesson)
    console.log("LUCatSeqNo: ", LUCatSeqNo)

    let objGCShare = {
        LessonID: window.gSession.App.CurrentLesson.ID,
        LUCatSeqNo: LUCatSeqNo
    }

    let strGCShareEncoded = encodeURIComponent(JSON.stringify(objGCShare))
    console.log("strGCShareEncoded: ", strGCShareEncoded)

    // strUrl = 'https://dcpdev.betterchinese.com/?Env=2&GCShare=' + strGCShareEncoded;
    let strUrl = window.gConfig.AppUrl + '&GCShare=' + strGCShareEncoded;

    return strUrl
} // end of GenerateShare2GoogleClassroomUrl
/*===========================================
summary: 取得 使用者暫存資料 的 Url
  param: 

retruns: 
remarks: 000 Tim 2019/09/26 Create
===========================================*/
function GetUserNewAssignmentTmpUrl(BookCategoryID, LessonID, LUCatSeqNo, AccountID, FileName, AnswerID)
{
    console.log(COMP_NAME + '.GetUserNewAssignmentTmpUrl: ', BookCategoryID, LessonID, LUCatSeqNo, AccountID, FileName, AnswerID);

    // https://appfsdev.betterchinese.com/UserUpload/NewAssignmentTmp/NewAssignmentTmp_BCat3_L3001_LU14_A192/ ImgAns01_BCat3_L3001_LU14_A192_8__192.jpg
    // https://appfsdev.betterchinese.com/UserUpload/NewAssignmentTmp_BCat3_L3001_LU14_A192/ImgAns01_BCat3_L3001_LU14_A192_8__192.jpg
    // https://appfsdev.betterchinese.com/UserUpload/NewAssignment_1898/RecAns_1898_8_193.mp3

    let intBookCategoryID = parseInt(BookCategoryID);
    let intLessonID = parseInt(LessonID);
    let intLUCatSeqNo = parseInt(LUCatSeqNo);
    let intAccountID = parseInt(AccountID);
    // let intAnswerID = 0;

    // NewAssignmentTmp/NewAssignmentTmp_ "BCat".(int)$BookCategoryID."_L".(int)$LessonID."_LU".(int)$LUCatSeqNo."_A".$intAccountID;
    let strASFolder = "NewAssignmentTmp/NewAssignmentTmp_"
        + "BCat" + intBookCategoryID
        + "_L" + intLessonID
        + "_LU" + intLUCatSeqNo
        + "_A" + intAccountID
        + "/";

    let strUrl = window.gConfig.UserUploadUrl + strASFolder + FileName;

    if (
        (typeof (AnswerID) !== 'undefined') &&
        (AnswerID != null) &&
        (parseInt(AnswerID) > 0)
        )
    {
        strUrl += "?AnswerID=" + AnswerID;
    }

    console.log("GetUserNewAssignmentTmpUrl: strUrl: ", strUrl);

    return strUrl;
} // end of GetUserNewAssignmentTmpUrl

function GetUserNewAssignmentUrl(AssignID, FileName)
{
    console.log("GetUserNewAssignmentUrl: ", AssignID, FileName);

    // https://appfsdev.betterchinese.com/UserUpload/NewAssignment_7/ImgAns01__8_0_85.jpg
    // https://appfsdev.betterchinese.com/UserUpload/NewAssignment_1898/RecAns_1898_8_193.mp3

    let strASFolder = "NewAssignment_" + AssignID + "/";

    let strUrl = window.gConfig.UserUploadUrl + strASFolder + FileName;

    console.log("GetUserNewAssignmentUrl: strUrl: ", strUrl);
    return strUrl;
} // end of GetUserNewAssignmentUrl

/*===========================================
summary: 取得 LU 音檔 圖檔 路徑
remarks: 001 Tim 2022/08/09 註解 App 取得資料 流程
         002 Tim 2022/09/01 移除 App 取得資料 流程
===========================================*/
function GetResourcePrefix(BookCategoryID, LessonID, ResourceType)
{
    console.log(COMP_NAME + ".GetResourcePrefix: ", BookCategoryID, LessonID, ResourceType);

    // let strBookCategoryFolder = "Category_" + BookCategoryID;
    let strLessonFolder = "Lesson_" + LessonID;
    let strResourceTypeFolder = "image";

    switch (ResourceType)
    {
        case window.gResourceTypeEnum.Audio:
            strResourceTypeFolder = "audio";
            break;
        case window.gResourceTypeEnum.Video:
            strResourceTypeFolder = "video";
            break;
        default:
            break;
    }

    // 移除 App 取得資料 流程   Tim22.08.09

    console.log("Not InApp: ", PackageVariablesLibs.SysConfig.FileServerURL)
    // strImagePrefix = 'http://54.165.87.220/FileServer/original/Lesson_01001/image/';
    let strPrefix = PackageVariablesLibs.SysConfig.FileServerURL + strLessonFolder + "/" + strResourceTypeFolder + "/"

    console.log("strPrefix: ", strPrefix)
    return strPrefix;
} // end of GetResourcePrefix


// richard: 把 <style>...</style> 移除
function ReplaceContentStyle(ContentHTML)
{
    console.log(COMP_NAME + '.ReplaceContentStyle: ', ContentHTML);

    let strContentText = ContentHTML;
    let strPrefixStyle = ""
    let strSubfixStyle = ""
    let strResult = ""

    let intIndex = strContentText.indexOf("<style>");
    if (intIndex > 0)
    {
        strPrefixStyle = strContentText.split("<style>")[0]
        console.log("strPrefixStyle: ", strPrefixStyle)

        let marrTokens = strContentText.split("</style>")
        console.log("marrTokens: ", marrTokens)
        strSubfixStyle = marrTokens[marrTokens.length - 1]
        console.log("strSubfixStyle: ", strSubfixStyle)

        strResult = strPrefixStyle + strSubfixStyle

    }
    else
    {
        strResult = strContentText
    }

    console.log("strResult: ", strResult)
    return strResult
} // end of ReplaceContentStyle

/*===========================================
summary: 取得 縮圖 Url
         目前 SongPoster 有在使用
remarks: 000 Tim 2022/06/20 Create
===========================================*/
function GetImageThumbnailUrl(ImageUrl)
{
    console.log(COMP_NAME + ".GetImageThumbnailUrl: ", ImageUrl)

    // 目前 ImageUrl 一定會有 AccountName/ ..., 一定有 "/"
    let arrFileName = ImageUrl.split("/") // 用 "/" 切分， 有 foldername, 有 filename (最後一個)

    let intIndex = 0
    let intCount = arrFileName.length
    let strThumbnailUrl = ""

    // 0 ~ 倒數第二個是folder
    for (intIndex = 0; intIndex < intCount - 1; intIndex++)
    {
        strThumbnailUrl += arrFileName[intIndex] + "/"
    } // end of for (intIndex = 0;

    // 最後一個是filename, 在file之前加 Thumbnails folder
    strThumbnailUrl += "thumbnails/"
    strThumbnailUrl += arrFileName[intCount - 1]   // 最後 filename

    return strThumbnailUrl
}  // end of GetImageThumbnailUrl

// 取得ContentText內的所有圖片的資訊
function GetAllImageFromHTMLContent(HTMLContent)
{
    console.log(COMP_NAME + ".GetAllImageFromHTMLContent: ", HTMLContent)

    let arrImage = []
    // Convert String to HTML object
    let objDOMParser = new DOMParser();
    let objDOM = objDOMParser.parseFromString(HTMLContent, 'text/html')

    objDOM.querySelectorAll('img').forEach((element, ElementIndex) => {

        let strOriginalImageUrl = element.getAttribute('src')
        console.log("strOriginalImageUrl: ", strOriginalImageUrl)
        let strThumbnailImageUrl = window.Globals.GetImageThumbnailUrl(strOriginalImageUrl)
        console.log("strThumbnailImageUrl: ", strThumbnailImageUrl)

        let objImageInfo = {
            OriginalImageUrl: strOriginalImageUrl,
            ThumbnailImageUrl: strThumbnailImageUrl,
            Width: null,
            Height: null,
            DisplayWidth: null,
            DisplayHeight: null
        }
        console.log("objImageInfo: ", objImageInfo)
        arrImage.push(objImageInfo)
    })

    return arrImage
}

// 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
function ChangeAllImageToThumbnailImageAndSpecifyWithHeight(HTMLContent, ImageList)
{
    console.log(COMP_NAME + ".ChangeAllImageToThumbnailImageAndSpecifyWithHeight: ", HTMLContent, ImageList)

    console.log("HTMLContent: ", HTMLContent)
    console.log("ImageList: ", ImageList)
    // Convert string to html
    // let objDOMParser = new DOMParser();
    // let objDOM = objDOMParser.parseFromString(HTMLContent, 'text/html')

    let objDOM = document.createElement('div');
    objDOM.innerHTML = HTMLContent;

    objDOM.querySelectorAll('img').forEach((element, elementIndex) => {

        let strOriginalImageUrl = element.getAttribute('src')
        console.log("strOriginalImageUrl: ", strOriginalImageUrl)
        let strThumbnailImageUrl = window.Globals.GetImageThumbnailUrl(strOriginalImageUrl)
        console.log("strThumbnailImageUrl: ", strThumbnailImageUrl)

        // 將圖片改為為縮圖
        element.setAttribute("src", strThumbnailImageUrl)

        console.log("ImageList[elementIndex]: ", ImageList[elementIndex])

        // element.getAttribute("class")
        // console.log("element.parentElement_class", element.parentElement.getAttribute("class"))
        // console.log("element.parentElement_indexOf: ", element.parentElement.getAttribute("class").indexOf("MainContainer"))

        if (
            (element.getAttribute("class").indexOf("BackgroundImg") !== -1) && // <img 的 class 有 BackgroundImg
            (element.parentElement.getAttribute("class").indexOf("MainContainer") !== -1) // <img 的 parent 的 class 有 MainContainer
            )
        {
            // <img 的 parent element 的 class 中有 MainContainer 才加 style
            // 設定圖片的寬高 直接在在 <img 設定style 圖片會往上跑 仍必須設定在 <img 的 parent <span class="MainContainer 
            let strStyle = "width: " + ImageList[elementIndex].DisplayWidth.toString() + "px;"
            strStyle += "height: " + ImageList[elementIndex].DisplayHeight.toString() + "px;"
            element.parentElement.style = strStyle
        }

        // element.style.cssText = "width: " + ImageList[elementIndex].DisplayWidth.toString() + "px;" + "height: " + ImageList[elementIndex].DisplayHeight.toString() + "px;"; // 不用此行 因為設定在 <img 後 雖有正確寬高 但位置會跑掉
        /*
        <div>
        <span class="MainContainer RFCImageL" style="width: 700px; height: 434px;">
            <img class="BackgroundImg RFCImageL" src="https://appfsdev.betterchinese.com/original/Lesson_03041/image/04041_langtips_main_01.png">
            <img class="FrontImg RFCImageL" src="https://appfsdev.betterchinese.com/original/Lesson_03041/image/04041_langtips_minor_01.png">
        </span>
        <br>
        <br>
        你好 / 您好！and some other greetings such as 最近還好嗎？are usually used at the beginning of the letter. In Chinese formal writing, you should leave a two-character space whenever you want to start a new paragraph.<br>
        <br>
        When you finish the main body of the letter, you can sign off with a phrase such as 祝好！("All the best"), or 問候你的家人 ("Best regards to your family").<br>
        <br>
        Finally, write your name and the date on the bottom right of the letter. The sequence of the date should be, year / month / day, as opposed to the American date format, month / day / year.</div>
        */
    })

    console.log("objDOM: ", objDOM)

    // Convert HTML object to String 
    let strResult = ""
    if (objDOM !== null)
    {
        strResult = objDOM.outerHTML
    }
    else
    {
        // 純文字
        strResult = HTMLContent
    }

    console.log("strResult: ", strResult)
    return strResult
}

// 將ContentText內的 某張圖 從縮圖改為原圖
function ChangeThumbnailImageUrlToOriginalImageUrl(HTMLContent, ImageIndex, OriginalImageUrl)
{
    console.log(COMP_NAME + ".ChangeThumbnailImageUrlToOriginalImageUrl: ", HTMLContent, ImageIndex, OriginalImageUrl)

    let objDOM = document.createElement('div');
    objDOM.innerHTML = HTMLContent;

    // Convert string to html
    objDOM.querySelectorAll('img')[ImageIndex].setAttribute("src", OriginalImageUrl)

    console.log("objDOM: ", objDOM)
    let objDiv = objDOM.querySelector('div')
    console.log("objDOM.querySelector('div'): ", objDOM.querySelector('div'))

    // Convert HTML object to String 
    let strResult = ""
    if (objDiv !== null)
    {
        strResult = objDiv.outerHTML
    }
    else
    {
        // 純文字
        strResult = HTMLContent
    }

    console.log("strResult: ", strResult)
    return strResult
}

/*===========================================
summary: 產生 Content Text
remarks: 000 Tim 2021/12/02 Create
         001 Tim 2022/01/06 支援Reading 刪除 多的 font-size
         002 Tim 2022/01/06 支援組合題 刪除 多的 height
         003 Jeff 2022/08/24 增加 取得 ImageList資料，ContentText中 所有Image的圖片資訊     Tim幫忙註解
===========================================*/
function CreateContentText(ContentHTML, KeywordList, ImagePrefix)
{
    console.log(COMP_NAME + ".CreateContentText: ", ContentHTML, KeywordList)

    let objContent = {
        "ContentText": '',
        "IsFontCN": false,
        "AudioFN": '',
        "IsAudio": false,
        "ImageList": [] // 裡面 需要重新計算 顯示高度的圖片資訊
    }

    let strContentText = window.Globals.ReplaceContentStyle(ContentHTML)
    console.log(COMP_NAME + ".CreateContentText strContentText: ", strContentText)

    let intPos = 0
    let strFront = ""
    let strBackend = ""

    let strKeyword = ""
    let intIndex = 0
    let intCount = 0

    // 把keywork塞進去
    for (intIndex in KeywordList)
    {
        intPos = strContentText.search('%@')
        strFront = strContentText.substring(0, intPos)
        strBackend = strContentText.substring(intPos + 2, strContentText.length)

        strKeyword = ""

        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strKeyword = KeywordList[intIndex].replace(' style=font-family:STKaiti-SC-Regular', '')
            objContent.IsFontCN = true
        }
        else
        {
            strKeyword = KeywordList[intIndex].replace(' style=font-family:DFKaiShu-SB-Estd-BF', '')
            objContent.IsFontCN = true
        }

        strContentText = strFront + strKeyword + strBackend;
    } // end of for (intIndex in KeywordList)

    strContentText = strContentText.replace(/ style=font-family:'Times New Roman'/g, '')
    strContentText = strContentText.replace(/<font>/g, '')
    strContentText = strContentText.replace(/<\/font>/g, '')
    strContentText = strContentText.replace(/<div>/g, '')
    strContentText = strContentText.replace(/<\/div>/g, '')

    // =========== 為了 Reading 處理 多的 font-size BEGIN ===========
    let intFront = 0
    let intBackend = 0
    let blnFound = true
    let strStyleKey = ""
    // 刪除 style="font-size:
    while (blnFound)
    {
        intFront = strContentText.indexOf(' style="font-size:')
        // console.log(COMP_NAME + ".CreateContentText intFront: ", intFront)

        if (intFront === -1)
        {
            blnFound = false
        }
        else
        {
            // 找到 style="font-size:XXX "; 後 把他刪除
            intBackend = strContentText.indexOf('"', (intFront + 18)) + 1
            strStyleKey = strContentText.substring(intFront, intBackend)
            strContentText = strContentText.replace(strStyleKey, '')

            // console.log(COMP_NAME + ".CreateContentText intBackend: ", intBackend)
            // console.log(COMP_NAME + ".CreateContentText strStyleKey: ", strStyleKey)
            // console.log(COMP_NAME + ".CreateContentText 33 strContentText: ", strContentText)
        }
    } // end of while (blnFound)
    // =========== 為了 Reading 處理 多的 font-size END ===========

    // =========== 處理 圖片顯示 刪除多的 style="height: BEGIN ===========
    intFront = 0
    intBackend = 0
    blnFound = true
    strStyleKey = ""
    // 刪除 style="height:
    while (blnFound)
    {
        intFront = strContentText.indexOf(' style="height:')
        // console.log(COMP_NAME + ".CreateContentText intFront: ", intFront)

        if (intFront === -1)
        {
            blnFound = false
        }
        else
        {
            // 找到 style="height: XXX ;" 後 把他刪除
            intBackend = strContentText.indexOf('"', (intFront + 18)) + 1
            strStyleKey = strContentText.substring(intFront, intBackend)
            strContentText = strContentText.replace(strStyleKey, '')

            // console.log(COMP_NAME + ".CreateContentText intBackend: ", intBackend)
            // console.log(COMP_NAME + ".CreateContentText strStyleKey: ", strStyleKey)
            // console.log(COMP_NAME + ".CreateContentText 33 strContentText: ", strContentText)
        }
    } // end of while (blnFound)
    // =========== 處理 圖片顯示 刪除多的 style="height: END ===========

    // 取出Audio(Listening Practice特例要取出Audio Name)
    let arrTmpText = strContentText.split('<BCAudio>')
    let arrTmpAudioFN = []
    let strAudioFN = ""

    if (arrTmpText[1] != null)
    {
        arrTmpAudioFN = arrTmpText[1].split('</BCAudio>')
        console.log(COMP_NAME + ".CreateContentText arrTmpAudioFN: ", arrTmpAudioFN)
        strAudioFN = arrTmpAudioFN[0]

        strContentText = arrTmpText[0].trim() + arrTmpAudioFN[1].trim()
        objContent.AudioFN = strAudioFN
        objContent.IsAudio = true
    }
    else
    {
        // down('#lblContentText').setWidth('100%');
        // 填入圖片的正確位置
        arrTmpText = strContentText.split('<BCImage>')
        console.log(COMP_NAME + ".CreateContentText arrTmpText: ", arrTmpText)
        strContentText = arrTmpText[0]
        intIndex = 0
        intCount = arrTmpText.length

        for (intIndex = 1; intIndex < intCount; intIndex++)
        {
            strContentText += ImagePrefix + arrTmpText[intIndex].replace('</BCImage>', '')
        } // end of for(intIndex = 1;
    }

    console.log(COMP_NAME + ".CreateContentText strContentText: ", strContentText)

    // // 建立 一個 div 將 有問題的 Html塞入
    // // Ex: <div style=font-family:'Times New Roman'><B>Dialogue 5</B></div>
    // // 再用 objDiv.textContent 輸出 裡面的 純文字
    // // Tim 21.12.02
    // let objDiv = document.createElement("div")
    // objDiv.innerHTML = strContentText
    // console.log(COMP_NAME + ".CreateContentText: objDiv: ", objDiv)
    // console.log(COMP_NAME + ".CreateContentText: objDiv.innerHTML: ", objDiv.innerHTML)
    // console.log(COMP_NAME + ".CreateContentText: objDiv.textContent: ", objDiv.textContent)

    // objContent.ContentText = objDiv.textContent
    objContent.ContentText = strContentText

    // 取得ContentText中 所有Image的圖片資訊
    objContent.ImageList = GetAllImageFromHTMLContent(objContent.ContentText)

    console.log(COMP_NAME + ".CreateContentText END objContent: ", objContent)
    
    return objContent
} // end of CreateContentText

/*===========================================
summary: 取得 書本編號 從 LessonID 反推
remarks: 000 Tim 2021/12/27 Create
===========================================*/
function GetBookSeqNoFromLessonID(LessonID)
{
    let intLessonID = parseInt(LessonID)
    let intBookSeqNo = 0
    switch ((intLessonID % 100))
    {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
            intBookSeqNo = 1
            break
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
            intBookSeqNo = 2
            break
        case 25:
        case 26:
        case 27:
        case 28:
        case 29:
        case 30:
        case 31:
        case 32:
        case 33:
        case 34:
        case 35:
        case 36:
            intBookSeqNo = 3
            break
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
            intBookSeqNo = 4
            break
        default:
            intBookSeqNo = 1
            break
    }

    return intBookSeqNo
}  // end of GetBookSeqNoFromLessonID

/*===========================================
summary: 是否 有寫入Log 的版本
remarks: 001 Tim 2022/10/25 增加註解 整理優化
         002 Tim 2023/09/11 將 判斷 是否 寫Log 
===========================================*/
function IsApplicationLogDump()
{
    let blnDumpLog = false

    if (process.env.REACT_APP_LOG_DUMP === "true")
    {
        blnDumpLog = true
    } // end of if (process.env.REACT_APP_LOG_DUMP === "true")
    return blnDumpLog
} // end of IsApplicationLogDump

// Export each function
export {
    GetUserDisplayName, // DCP
    FormateDisplayName, // DCP
    GetDisplayName, // DCP
    GetBookCategoryChineseName,
    GetBookCategoryEnglishName,
    CheckAuthorized,
    GetAuthorized,
    GetClassAccountRole,
    GetHaveStudentByClassAccountRole,
    GetHaveTeacherByClassAccountRole,
    GetImageThumbnailURL,
    GetImageThumbnailUrl,
    GetResourceUrl,
    GetQueryString4InApp,
    GetInAppQueryString4BCClass,
    GoToDefaultPage,
    GetAccountDisplayPic,
    GetScheduleDisplayTime,
    GetWeekNameByID,
    GetWeekAbbreviationByID,
    GetClassIDByTeacher,
    GetClassObjectByClassID,
    GetClassIndexByClassID,
    GetBookCategoryIDByClassID,
    GetTeacherList4Class,
    GotoClassOverview4Student4Notification,
    GetDateWithFormat,
    GetLessonIndex,
    GetEnglishLessonNumber,
    GetEnglishLessonNumberAndLessonName,
    GetLUName,
    GetBookCategoryID,
    GenerateShare2GoogleClassroomUrl,
    GetUserNewAssignmentTmpUrl,
    GetUserNewAssignmentUrl,
    GetResourcePrefix,
    ReplaceContentStyle,
    CreateContentText,
    GetBookSeqNoFromLessonID,
    ChangeAllImageToThumbnailImageAndSpecifyWithHeight,
    ChangeThumbnailImageUrlToOriginalImageUrl,
    IsApplicationLogDump

    // GetVideoPoster,
    // GetLearningUnitCacheIndex,
    // SetReturnFromApp, // richard removed
    // GetTotalFromApp,
    // ResetReturnFromAppByCallAction,
    // GeneratePreferenceKeyValue,
    // ConvertLocalDayTime2ServerDayTime,
    // ConvertServerDayTime2LocalDayTime4Schedule,
    // GetNotificationCancelAlertObject,
    // GetTimeFormatHHMMSS,
    // GetFormatNotificationMessage,
    // GetNotificationIndexInNotificationList,

}